module.exports = __webpack_public_path__ + "static/img/alzmh5.36e317f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alzmh5.png
// module id = /xc0
// module chunks = 0